export default "__VITE_ASSET__DDqOr8pE__"